"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const appConstants_1 = require("../../../../constants/appConstants");
const uiConstants_1 = require("../../../../constants/uiConstants");
const typeInputButtonSetting_1 = __importDefault(require("../../../molecules/setting/typeInputButtonSetting"));
const listTag_1 = __importDefault(require("../../../molecules/tag/listTag"));
const TypeInputButtonAdditionalSetting = ({ name = '', buttonName = '', buttonColor = uiConstants_1.UI_BUTTON_PRIMARY, placeholder = '', tags = [], onButtonClick = () => ({}), onTagClick = () => ({}), onChange = () => ({}), visible = true, disabled = false, mainClass = '', size, style = {}, dataTestId = '', } = {}) => {
    const [inputValue, setInputValue] = (0, react_1.useState)('');
    const onInputChange = (_key, value) => {
        setInputValue(value);
        onChange(name, value);
    };
    const onAddButtonClick = () => {
        setInputValue('');
        onButtonClick(appConstants_1.companyPropertiesExtendedConstants.addWhiteListedDomain, inputValue);
    };
    const onRemoveButtonClick = value => {
        onTagClick(appConstants_1.companyPropertiesExtendedConstants.removeWhiteListedDomain, value);
    };
    return visible ? ((0, jsx_runtime_1.jsxs)(material_1.Box, { component: "div", className: mainClass, children: [(0, jsx_runtime_1.jsx)(typeInputButtonSetting_1.default, { dataTestId: dataTestId, name: name, inputValue: inputValue, buttonName: buttonName, buttonType: buttonColor, size: size, placeholder: placeholder, onClick: onAddButtonClick, onValueChange: onInputChange, disabled: disabled }), !!String(tags) && ((0, jsx_runtime_1.jsx)(listTag_1.default, { labels: tags.filter(Boolean).map(tag => ({
                    key: tag,
                    label: tag,
                })), onClick: onRemoveButtonClick, style: {
                    ...style,
                    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? {
                            justifyContent: 'space-between',
                            display: 'flex',
                        }
                        : {}),
                } }))] })) : null;
};
exports.default = TypeInputButtonAdditionalSetting;
